import { handleActions } from 'redux-actions'
import { set } from 'lodash/fp'
import { ISpecies, SET_SPECIES, UPDATE_SPECIES_GROUP } from './speciesActions'

const DEFAULT_STATE = {
  species: [] as ISpecies[],
}

export default handleActions<typeof DEFAULT_STATE, any>(
  {
    [SET_SPECIES]: (state, { payload }: SET_SPECIES) =>
      set('species', payload, state),
    [UPDATE_SPECIES_GROUP]: (state, { payload }: UPDATE_SPECIES_GROUP) =>
      set(
        'species',
        state.species.map((item) =>
          item.id === payload.id ? { ...item, group: payload.group } : item,
        ),
        state,
      ),
  },
  DEFAULT_STATE,
)
